import { render, staticRenderFns } from "./ApuracaoAcaoFluxo.vue?vue&type=template&id=55857501"
import script from "./ApuracaoAcaoFluxo.vue?vue&type=script&lang=js"
export * from "./ApuracaoAcaoFluxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports